import { Owned } from './named';
import { } from './annotation';
import { Metamodel } from './model';

@Metamodel.model({
    name: 'User Property',
    display: ['userProperty', 'UserProperties'],
    referable: true
})
export class UserProperty extends Owned {
    public name: string;
    public value: string;

    constructor(name?: string, value?: string) {
        super();
        this.name = name;
        this.value = value;
    }
}
